import React, { Fragment, useRef, useState } from 'react';
import ReactToPrint from 'react-to-print';
import { Modal, Form, Select, Button } from 'antd';
import { languages } from '../../../../I18n/TranslateText';
import PrintPreview from './PrintPreview';

const PrintPreviewModal = ({ open, handleClose, printProps }) => {
  const { currentPatient } = printProps;

  const [currLanguage, setCurrLanguage] = useState(null);
  const printRef = useRef(null);

  const [form] = Form.useForm();

  const handleSubmit = () => {
    form.submit();

    setCurrLanguage(form.getFieldValue('currLanguage'));
  };

  return (
    <Modal
      title="Print Preview"
      open={open}
      onCancel={handleClose}
      maskClosable={false}
      width={950}
      bodyStyle={{
        ...(currLanguage && { height: '70vh' }),
        overflow: 'auto',
      }}
      footer={[
        currLanguage ? (
          <Fragment>
            <ReactToPrint
              onBeforeGetContent={() => {
                document.title = `${currentPatient.FirstName}_${currentPatient.LastName}`;
              }}
              onAfterPrint={() => {
                document.title = 'PT Wired';
              }}
              removeAfterPrint={true}
              content={() => printRef.current}
              trigger={() => (
                <Button type="primary" className="ptw-btn">
                  Print
                </Button>
              )}
            />
            <Button onClick={() => setCurrLanguage(null)}>
              Re-select Language
            </Button>
          </Fragment>
        ) : (
          <Button type="primary" className="ptw-btn" onClick={handleSubmit}>
            Continue
          </Button>
        ),
        <Button
          type="default"
          className="ptw-btn"
          onClick={() => {
            form.resetFields();
            setCurrLanguage(null);
            handleClose();
          }}
        >
          Cancel
        </Button>,
      ]}
    >
      {currLanguage ? (
        <PrintPreview
          printRef={printRef}
          currLocale={currLanguage}
          printProps={printProps}
        />
      ) : (
        <Form form={form} initialValues={{ currLanguage: 'en' }}>
          <Form.Item
            label="Language"
            name="currLanguage"
            help="Select the language you'd like to use for this printout."
          >
            <Select
              showSearch
              placeholder="Select a language"
              filterOption={(input, option) => {
                if (option && option.label) {
                  const label = String(option.label).toLowerCase();
                  if (label.includes(String(input).toLowerCase())) {
                    return option;
                  }
                }
              }}
              options={languages
                .sort((a, b) => a.name - b.name)
                .map(l => ({
                  value: l.locale,
                  label: l.name,
                }))}
            />
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
};

export default PrintPreviewModal;
